//ENUMS

export enum USERROLE {
  NULL = 'NULL',
  FA = 'FA',
  BM = 'BM',
  HO = 'HO',
  COMP = 'COMP',
  OPS = 'OPS',
  SUPER = 'SUPER',
  SUPERVISION = 'SUPERVISION',
  AML = 'AML'
}

export enum DATA_TYPE {
  STR = 'STR',
  NUM = 'NUM',
  AMT = 'AMT',
  PCT = 'PCT',
  ARR = 'ARR',
  DATE = 'DATE',
}

export enum ALIGN {
  R = 'R',
  L = 'L',
  C = 'C',
}

export enum FACET_SOURCE {
  API = 'API',
  FIXED = 'FIXED',
}

export enum FILTER_TYPE {
  NONE = 'NONE',
  CHKBOX = 'CHKBOX',
  TXT = 'TXT',
  RANGE = 'RANGE',
  DD = 'DD',
  RADIO = 'RADIO',
}

export enum OPERATOR {
  EQ = 'EQ',
  GTE = 'GTE',
  LTE = 'LTE',
  BET = 'BET',
  CONTAINS = 'CONTAINS',
  IN = 'IN',
}

export enum SUPERVISIONITEMSTATUS {
  NULL,
  OPEN,
  DEFERRED,
  CLOSED,
}

export enum SUPERVISIONRESPONSEUSRTYPE {
  NULL,
  DBD,
  CSC,
}

export enum WorkflowStatus {
  OPEN = 'OPEN',
  // DBDREVIEW = 'DBDREVIEW',
  // REOPENED = 'REOPENED',
  PENDING = 'PENDING', // Accounts that are not reviewed / acted upon(Default)
  SUBMITTED = 'SUBMITTED', // Attested by PW
  RETURNEDBM = 'RETURNED-BM', // Returned by DBD
  RESUBMITTED = 'RESUBMITTED', // Re-submitted by Advisor
  CLOSED = 'CLOSED', // Accounts that are reviewed and closed
  RETURNEDBYCP = 'RETURNED-BY-CP', // Returned by Control Person
  RETURNEDTOCP = 'RETURNED-TO-CP', // Returned to Control Person
  SKIPPED = 'SKIPPED', // Accounts that are skipped by Supervision team
  EXT_REQ = 'EXT-REQ',
  EXC_REQ = 'EXC-REQ',
  EXT_APR = 'EXT-APVD',
  EXC_APR = 'EXC-APVD',
  PENDING_OVERDUE = 'PENDING-OVERDUE',
  PENDING_REOPEN = 'PENDING-REOPEN',
  ACCESSIBLE = 'ACCESSIBLE'
}